import differenceInCalendarMonths from 'date-fns/differenceInCalendarMonths';

import { MINIMUM_RESIDENCE_HISTORY } from '../constants/thresholds';

const buildRange = (sYear, sMonth, eYear, eMonth) => {
  const sDate = new Date(sYear, sMonth);
  const eDate = new Date(eYear, eMonth);
  let comparisonDate = new Date(eDate);
  let index = eDate.getMonth();
  const range = [];
  while (comparisonDate > sDate) {
    const tmpDate = new Date(eDate);
    tmpDate.setMonth(index);
    comparisonDate = new Date(tmpDate.getFullYear(), tmpDate.getMonth());
    range.push(`${tmpDate.getMonth()}-${tmpDate.getFullYear()}`);
    index -= 1;
  }
  return range;
};

const buildRangeTo = (endDate, monthCount) => {
  const tmpDate = new Date(endDate);
  tmpDate.setMonth(tmpDate.getMonth() + 1 - monthCount);
  const startDate = new Date(tmpDate);
  const sYear = startDate.getFullYear();
  const sMonth = startDate.getMonth();
  const eYear = endDate.getFullYear();
  const eMonth = endDate.getMonth();
  return buildRange(sYear, sMonth, eYear, eMonth);
};

const residenceEndDate = (currentDate, previousResidence) => {
  let endDate = [currentDate.getFullYear(), currentDate.getMonth()];
  if (previousResidence) {
    if (previousResidence.startMonth === 0) {
      endDate = [previousResidence.startYear - 1, 11];
    } else {
      endDate = [previousResidence.startYear, previousResidence.startMonth - 1];
    }
  }
  return endDate;
};

const buildResidenceRange = (currentResidence, previousResidence, currentDate) => {
  const { startYear, startMonth } = currentResidence;
  const [endYear, endMonth] = residenceEndDate(currentDate, previousResidence);
  let range = [`${startMonth}-${startYear}`];
  if (startYear !== endYear || startMonth !== endMonth) {
    range = buildRange(startYear, startMonth, endYear, endMonth);
  }
  return range;
};

const unaccountedForMonths = (residences, currentDate) => {
  const monthRange = buildRangeTo(currentDate, MINIMUM_RESIDENCE_HISTORY);
  const allResidenceRanges = residences.map((currentResidence, index) => {
    const previousResidence = residences[index - 1];
    return buildResidenceRange(currentResidence, previousResidence, currentDate);
  });
  const combinedResidences = allResidenceRanges.reduce((prev, current) => prev.concat(current), []);
  const nonAllocatedMonths = monthRange.filter(date => !combinedResidences.includes(date));
  return nonAllocatedMonths.length;
};

const differenceInMonths = (startDate, endDate) => {
  return differenceInCalendarMonths(endDate, startDate) + 1;
};

const dayOptions = (dayRange, placeholder) => {
  const days = [...Array(dayRange).keys()].map(i => {
    const day = (i + 1).toString();
    return { value: day, label: day };
  });

  return [placeholder('Day'), ...days];
};

const monthOptions = (monthNames, placeholder) => {
  const months = monthNames.map((name, index) => {
    return {
      value: index.toString(),
      label: name,
    };
  });

  return [placeholder('Month'), ...months];
};

const yearOptionsAscending = (minYearRange, maxYearRange, placeholder) => {
  const minYear = new Date(Date.now()).getFullYear() - minYearRange;
  const years = [...Array(maxYearRange).keys()].map(i => {
    const year = (minYear + i).toString();
    return { value: year, label: year };
  });

  return [placeholder('Year'), ...years];
};

const yearOptionsDescending = (yearRange, minAge = 0, placeholder) => {
  const currentYear = new Date(Date.now()).getFullYear() - minAge;
  const years = [...Array(yearRange).keys()].map(i => {
    const year = (currentYear - i).toString();
    return { value: year, label: year };
  });

  return [placeholder('Year'), ...years];
};

export {
  buildRangeTo,
  buildRange,
  residenceEndDate,
  unaccountedForMonths,
  differenceInMonths,
  dayOptions,
  monthOptions,
  yearOptionsAscending,
  yearOptionsDescending,
};
